import { render, staticRenderFns } from "./sendSMS.vue?vue&type=template&id=68129301&scoped=true&"
import script from "./sendSMS.vue?vue&type=script&lang=js&"
export * from "./sendSMS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68129301",
  null
  
)

export default component.exports